export default "__VITE_ASSET__jeO$46nC__"